import { cloneElement, isValidElement, useId, type ReactElement } from 'react';

/**
 * Label + control + hint/error. The one form-row pattern (uses the .label
 * class). Clones its single child to inject a generated id for htmlFor.
 */
export function FormField({
  label,
  error,
  hint,
  children,
}: {
  label: string;
  error?: string | null;
  hint?: string;
  children: ReactElement;
}) {
  const generatedId = useId();
  const childId =
    (isValidElement(children) && (children.props as { id?: string }).id) || generatedId;
  const control = isValidElement(children)
    ? cloneElement(children as ReactElement<{ id?: string }>, { id: childId })
    : children;

  return (
    <div>
      <label htmlFor={childId} className="label">
        {label}
      </label>
      {control}
      {error ? (
        <p role="alert" className="mt-1 text-xs text-danger-300">
          {error}
        </p>
      ) : hint ? (
        <p className="mt-1 text-xs text-ink-faint">{hint}</p>
      ) : null}
    </div>
  );
}
